import { InviteRequestDto } from "../../models/auto-generated/InviteRequestDto";
import { ActivateUserDto } from "../../models/auto-generated/ActivateUserDto";
import { fetchVeracity } from "../fetchVeracity";
import { fetchVeracityVoid } from "../fetchVeracity";

export class SignupService {
	/** Gets the current new user request */
	static getUserCreateRequest(requestId: string) {
		return fetchVeracity<ActivateUserDto>(
			`/api/signup/request/${encodeURIComponent(requestId)}`
		);
	}

	/** Gets the request id */
	static getRequestId(email: string, activationCode: string) {
		return fetchVeracity(
			`/api/signup/request/${encodeURIComponent(
				email
			)}/${encodeURIComponent(activationCode)}`, { method: "GET" }
		);
	}

	/**  */
	static inviteUsers(invite: InviteRequestDto) {
		return fetchVeracityVoid(`/api/signup/invite`, {
			method: "POST",
			body: JSON.stringify(invite),
			headers: { "Content-Type": "application/json" },
		});
	}
}
